import Service from './Service';
/**
 * Classe utilizada para tratar regras de negócio e manipular o retorno dos webservices
 */
class TipoAtendimentoService extends Service {
  async consultarTiposAtendimento () {
    let tiposAtendimento = [];
    let result = await this.getTipoAtendimentoApi().consultarTiposAtendimento();
    tiposAtendimento = result;

    return tiposAtendimento;
  }
  async consultarCaraterSolicitacao () {
    let caraterSolicitacao = [];
    let result = await this.getTipoAtendimentoApi().consultarCaraterSolicitacao();
    caraterSolicitacao = result;

    return caraterSolicitacao;
  }
  async alterarTipoAtendimentoSpsadt (codLoteGuia, codGuia, codTipoGuia, codTipoAtendimento) {
    let result = await this.getTipoAtendimentoApi().alterarTipoAtendimentoSpsadt(codLoteGuia, codGuia, codTipoGuia, codTipoAtendimento);
    return result;
  }
  async alterarCaraterSolicitacao (codLoteGuia, codGuia, codTipoGuia, codCaraterSolicitacao) {
    let result = await this.getTipoAtendimentoApi().alterarCaraterSolicitacao(codLoteGuia, codGuia, codTipoGuia, codCaraterSolicitacao);
    return result;
  }
}

export default TipoAtendimentoService;
